
function flattenResolved(nodes = [], acc = []) {
  (nodes || []).forEach((node) => {
    acc.push(node);
    flattenResolved(node.children || [], acc);
  });

  return acc;
}

function getNodeWorldBox(node) {
  const p = node?.worldTransform?.position || {};
  const g = node?.geometry || {};
  const ep = node?.effectiveParameters || {};

  const pp = node?.parameters || node?.parameterValues || {};

  const width = Number(g.width ?? ep.width ?? pp.width ?? 0);
  const height = Number(g.height ?? ep.height ?? pp.height ?? 0);
  const depth = Number(g.depth ?? ep.depth ?? pp.depth ?? 0);

  const cx = Number(p.x || 0);
  const cy = Number(p.y || 0);
  const cz = Number(p.z || 0);

  if (!width && !height && !depth) return null;

  return {
    min: {
      x: cx - width / 2,
      y: cy - height / 2,
      z: cz - depth / 2,
    },
    max: {
      x: cx + width / 2,
      y: cy + height / 2,
      z: cz + depth / 2,
    },
  };
}

function getOverallBox(nodes = []) {
  let box = null;

  flattenResolved(nodes).forEach((node) => {
    const b = getNodeWorldBox(node);
    if (!b) return;

    if (!box) {
      box = {
        min: { ...b.min },
        max: { ...b.max },
      };
      return;
    }

    box.min.x = Math.min(box.min.x, b.min.x);
    box.min.y = Math.min(box.min.y, b.min.y);
    box.min.z = Math.min(box.min.z, b.min.z);

    box.max.x = Math.max(box.max.x, b.max.x);
    box.max.y = Math.max(box.max.y, b.max.y);
    box.max.z = Math.max(box.max.z, b.max.z);
  });

  return box;
}

function getViewDimensionValues(box, view) {
  const type = view?.type || "front";

  if (type === "top") {
    return {
      horizontal: Math.round(box.max.x - box.min.x),
      vertical: Math.round(box.max.z - box.min.z),
    };
  }

  if (type === "right" || type === "left") {
    return {
      horizontal: Math.round(box.max.z - box.min.z),
      vertical: Math.round(box.max.y - box.min.y),
    };
  }

  if (type === "section") {
    return {
      horizontal: Math.round(box.max.x - box.min.x),
      vertical: Math.round(box.max.y - box.min.y),
    };
  }

  return {
    horizontal: Math.round(box.max.x - box.min.x),
    vertical: Math.round(box.max.y - box.min.y),
  };
}

function getViewportLayout(viewport = {}) {
  return {
    widthMm: Number(viewport.widthMm ?? viewport.width ?? 100),
    heightMm: Number(viewport.heightMm ?? viewport.height ?? 80),
  };
}

export function createOverallDimensionsForView({
  view,
  viewport,
  resolvedNodes,
}) {
  const box = getOverallBox(resolvedNodes);
  if (!box || !viewport?.id || !view?.id) return [];

  const layout = getViewportLayout(viewport);
  const values = getViewDimensionValues(box, view);

  const widthMm = layout.widthMm;
  const heightMm = layout.heightMm;

  const now = Date.now();

  return [
    {
      id: `dim_h_${viewport.id}_${now}`,
      type: "dimension",
      viewportId: viewport.id,
      viewId: view.id,
      mode: "overall",
      orientation: "horizontal",
      value: values.horizontal,
      text: `${values.horizontal} mm`,
      x1Mm: widthMm * 0.22,
      y1Mm: heightMm - 10,
      x2Mm: widthMm * 0.78,
      y2Mm: heightMm - 10,
      offsetMm: 8,
    },
    {
      id: `dim_v_${viewport.id}_${now}`,
      type: "dimension",
      viewportId: viewport.id,
      viewId: view.id,
      mode: "overall",
      orientation: "vertical",
      value: values.vertical,
      text: `${values.vertical} mm`,
      x1Mm: widthMm - 10,
      y1Mm: heightMm * 0.22,
      x2Mm: widthMm - 10,
      y2Mm: heightMm * 0.78,
      offsetMm: 8,
    },
  ];
}